import axios from 'axios';
import client from 'api/client';

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(url || '');

export const fetchPeaks = ({collectionId, peaksUrl, locale}) =>
  isAbsoluteUrl(peaksUrl)
    ? axios.get(peaksUrl)
    : client().get(peaksUrl || `/collections/v2/${collectionId}/peaks`, {locale});

export const generatePeaks = ({collectionId}) =>
  client().post(`pipeline/collection/${collectionId}/peaks`);
